/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import InputMask from 'react-input-mask';
import { I18n } from 'react-redux-i18n';
import moment from 'moment-timezone';

import RegexCards from '../../../app/utils/cards';

import StringHelper from '../../../helpers/string';

class CheckoutPaymentCard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      cvv: '',
      installments: 1,
      showModalDelete: false,
      phone: '',
      birthDate: '',
    };
  }

  componentDidMount = () => {
    if (this.props.paymentService === 'pagseguro') {
      this.checkPersonalData();
    }
  }

  numberOfInstallments = (total) => {
    const installmentsTotal = [];
    for (let i = 1; i <= total; i += 1) installmentsTotal.push(i);
    return installmentsTotal.map(p => <option key={p} value={p}>{`${p} x`}</option>);
  };

  removeCreditCardUser = async (card) => {
    await this.setState({ showModalDelete: false });
    await this.props.deleteCard(card);
  };

  setValue = async (key, value) => {
    if (key === 'birthDate') {
      if (!moment(value).isAfter(moment(new Date()).format('YYYY-MM-DD'))) {
        this.setState({
          birthDateError: false,
          [key]: value,
        });
      } else {
        this.setState({
          [`${key}Error`]: true,
          [key]: value,
        });
      }
    } else {
      this.setState({
        [`${key}Error`]: '',
        [key]: value,
      });
    }
  }

  checkData = async (type, card, cvv, installments) => {
    if (this.props.paymentService === 'pagseguro') {
      if (this.state.phone.length > 13) {
        this.props.setData({ phone: this.state.phone, birthDate: this.state.birthDate });
        this.props.setPayment(type, {
          card: {
            cardId: card.id,
            brand: card.brand,
            securityCode: cvv,
            installments,
          },
        });
      } else {
        await this.setState({
          phoneError: I18n.t('incompletePhoneError'),
        });
      }
    } else {
      this.props.setPayment(type, {
        card: {
          cardId: card.id,
          brand: card.brand,
          securityCode: cvv,
          installments,
        },
      });
    }
  }

  checkDisabled = (cvv) => {
    if (this.props.paymentService === 'pagseguro') {
      if (this.state.birthDateError === false && this.state.birthDate !== '') {
        return StringHelper.keepOnlyNumber(cvv).length < 3 || StringHelper.keepOnlyNumber(cvv).length > 4;
      }
      return true;
    }
    return StringHelper.keepOnlyNumber(cvv).length < 3 || StringHelper.keepOnlyNumber(cvv).length > 4;
  }

  checkPersonalData = () => {
    if (this.props.personalData && this.props.personalData.birthDate && !this.state.birthDate) {
      this.setValue('birthDate', this.props.personalData.birthDate);
    }
    if (this.props.personalData && this.props.personalData.phone && !this.state.phone) {
      this.setValue('phone', this.props.personalData.phone);
    }
  }

  render() {
    const {
      cvv, installments, showModalDelete, phone, birthDate, phoneError, birthDateError,
    } = this.state;
    const { card, type, installmentsTotal } = this.props;

    return (
      <div key={card.id} className="basket-card">
        <div
          className="modal"
          style={{ display: showModalDelete ? 'block' : 'none' }}
          onClick={() => {
            this.setState({ showModalDelete: false });
          }}
          role="presentation"
        >
          <div className="modal-content">
            <div className="modal-body">
              <div className="column body-modal-text">
                <h3 className="h3-modal-div">{`${I18n.t('wishToDeleteCard')} ${I18n.t(type)}?`}</h3>
                <h4 className="h4-modal-div">{`${card.name} ${card.expirationDate} ${card.number}`}</h4>
              </div>
              <div className="row body-modal-div">
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModalDelete: false })}
                >
                  {I18n.t('cancel')}
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.removeCreditCardUser(card)}
                >
                  {I18n.t('remove')}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card cursorPointer">
          <span
            className="flag"
            style={{ backgroundImage: `url(${RegexCards.getCardsUrl(card.brand) || '/images/product-image-placeholder.png'})` }}
          />
          <span className="number">
            {`${card.name} ${card.expirationDate}`}
            &nbsp;
            &nbsp;
            {`${card.number}`}
          </span>
          <span
            className="remove"
            onClick={() => {
              this.setState({ showModalDelete: true });
            }}
            role="presentation"
          >
            {I18n.t('remove')}
          </span>
        </div>

        <div className="basket-form basket-form-add">
          <div className="basket-form__group">
            <label className="lbl">
              {I18n.t('securityCode')}
              <InputMask
                mask={RegexCards.getMaskCard(card.brand)}
                value={this.state.cvv}
                onChange={e => this.setState({ cvv: e.target.value })}
              >
                {inputProps => (
                  <input
                    {...inputProps}
                    className="fld"
                    type="text"
                    placeholder={I18n.t('cvv')}
                    required
                  />
                )}
              </InputMask>
            </label>
          </div>
          {type === 'credit' && (
            <div className="basket-form__group">
              <label className="lbl">
                {I18n.t('installments')}
                <div className="select select--white">
                  <select
                    defaultValue="num"
                    onChange={e => this.setState({ installments: Number(e.target.value) })}
                  >
                    {this.numberOfInstallments(installmentsTotal)}
                  </select>
                </div>
              </label>
            </div>
          )}
          {(this.props.paymentService === 'pagseguro')
            ? (
              <div>
                <div className="basket-form__group">
                  <label className="lbl">
                    {I18n.t('phone2')}
                    <InputMask
                      tabIndex="-1"
                      className="fld"
                      type="text"
                      mask={phone.length > 14 ? '(99) 9 9999-9999' : '(99) 9999-99999'}
                      maskChar={null}
                      value={phone}
                      onChange={e => this.setValue('phone', e.target.value)}
                      required
                    />
                  </label>
                  {phoneError ? (
                    <div style={{ height: 50 }}>
                      <p className="error-msg">{phoneError}</p>
                    </div>
                  ) : ''}
                </div>
                <div className="basket-form__group">
                  <label className="lbl">
                    {I18n.t('birthDate2')}
                    <input
                      tabIndex="-1"
                      className="fld"
                      type="date"
                      value={birthDate}
                      onChange={e => this.setValue('birthDate', e.target.value)}
                      required
                    />
                  </label>
                  {birthDateError ? (
                    <div style={{ height: 50 }}>
                      <p className="error-msg">{I18n.t('errorDateReported')}</p>
                    </div>
                  ) : ''}
                </div>
              </div>
            )
            : ''
          }
          <div className="basket-form__btns">
            <button
              type="button"
              className="btn"
              onClick={() => this.checkData(type, card, cvv, installments)}
              disabled={this.checkDisabled(cvv)}
            >
              {I18n.t('confirm')}
            </button>
          </div>
        </div>

        <div className="card-image" />
      </div>
    );
  }
}


export default CheckoutPaymentCard;
